'use client';

import { useEffect, useState } from 'react';

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkTablet = () => {
      if (typeof window === 'undefined') return;
      // Treat tablet and smaller as "mobile-style" header
      setIsTablet(window.matchMedia('(max-width: 1023px)').matches);
    };

    checkTablet();
    window.addEventListener('resize', checkTablet);
    return () => window.removeEventListener('resize', checkTablet);
  }, []);

  return isTablet;
};
